import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isConnected: false,
    token: localStorage.getItem('mpass-web-widget-chat-token') === 'null' ? null : localStorage.getItem('mpass-web-widget-chat-token'),
    agent: localStorage.getItem('mpass-web-widget-chat-agent') === 'null' ? null : localStorage.getItem('mpass-web-widget-chat-agent') === 'true',
    clientImage: null
  },
  getters: {
    getToken: state => state.token,
    getAgent: state => state.agent,
    getClientImage: state => state.clientImage
  },
  mutations: {
    SOCKET_CONNECT(state) {
      state.isConnected = true;
    },

    SOCKET_DISCONNECT(state) {
      state.isConnected = false;
    },

    SOCKET_SETJWT(state, value) {
      state.token = value
    },

    setAgent(state, value) {
      state.agent = value
    },
    setClientImage(state, value) {
      state.clientImage = value
    }
  },
  actions: {
    setToken({ commit }, token) {
      localStorage.setItem('mpass-web-widget-chat-token', token)
      commit('SOCKET_SETJWT', token)
    },
    setAgent({ commit }, agent) {
      localStorage.setItem('mpass-web-widget-chat-agent', agent)
      commit('setAgent', agent)
    },
    clearConversation({ commit, dispatch }) {
      localStorage.removeItem('mpass-web-widget-chat-token')
      dispatch('setAgent', false)
      commit('SOCKET_SETJWT', null)
    },
    setClientImage({ commit }, clientImage) {
      commit('setClientImage', clientImage)
    }
  },
  modules: {
  }
})
